import { CliData, Param } from '../cliDataSchema';
import {
  DEFAULT_FEATURE_GROUP,
  DEFAULT_PARAM_GROUP,
  RECOMMENDED_FEATURE_GROUP,
} from '../utils/consts';

/**
 * Organizes CLI parameters by feature and parameter groups.
 * @param cliData - The CLI data to organize.
 * @returns A nested structure grouping parameters by feature and parameter groups.
 */
export const organizeParamsByFeatureGroup = (
  cliData: CliData | undefined,
): Record<string, Record<string, Param[]>> => {
  if (!cliData || !cliData.commands) {
    return { [DEFAULT_FEATURE_GROUP]: { [DEFAULT_PARAM_GROUP]: [] } };
  }

  return cliData.commands.reduce(
    (featureGroups: Record<string, Record<string, Param[]>>, commandGroup) => {
      commandGroup.commands?.forEach((command) => {
        command.params?.forEach((param) => {
          if (!param.osep_generator_ui_allow_presets) {
            return;
          }

          const featureGroup = param.osep_generator_ui_recommended
            ? RECOMMENDED_FEATURE_GROUP
            : param.osep_generator_ui_feature_group || DEFAULT_FEATURE_GROUP;

          const paramGroup =
            param.osep_generator_ui_param_group || DEFAULT_PARAM_GROUP;

          if (!featureGroups[featureGroup]) {
            featureGroups[featureGroup] = {};
          }
          if (!featureGroups[featureGroup][paramGroup]) {
            featureGroups[featureGroup][paramGroup] = [];
          }

          const isNameAlreadyInGroup = featureGroups[featureGroup][
            paramGroup
          ].some((existingParam) => existingParam.name === param.name);

          if (isNameAlreadyInGroup) {
            return;
          }

          featureGroups[featureGroup][paramGroup].push(param);
        });
      });

      return featureGroups;
    },
    { [DEFAULT_FEATURE_GROUP]: { [DEFAULT_PARAM_GROUP]: [] } },
  );
};
